define(
({
  "select_shipping_method": "选择送货方式"
})
);
